export default "__VITE_ASSET__bBgmPsJb__"